import { render, staticRenderFns } from "./LayoutObserver.vue?vue&type=template&id=e19a92d0"
import script from "./LayoutObserver.vue?vue&type=script&lang=ts"
export * from "./LayoutObserver.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports